export type DumpFormat = 'tsv' | 'parquet';

/**
 * Update these checksums whenever a new dump is published on the API.
 * They are shown in Tools → Download so users can verify their download.
 */
export const DUMP_MD5 = {
  tsv: 'c2c22f462a73343e3b635de5ef30eac1',
  parquet: '66d27af9a94b173bc2115cbd981ddcee',
} as const satisfies Record<DumpFormat, string>;

export function getDumpBaseUrl(apiBase = process.env.REACT_APP_URL_API_API ?? ''): string {
  return apiBase.endsWith('/') ? apiBase : `${apiBase}/`;
}
